export const ROUTES = {
  AUTH: {
    LOGIN: '/auth/login',
    SIGNUP: '/auth/signup',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password',
    CALLBACK: '/auth/callback',
  },
  ONBOARDING: {
    ROOT: '/onboarding',
    STEP: (step: number) => `/onboarding/step-${String(step)}`,
  },
  DASHBOARD: '/',
  PROCESSES: '/processes',
  DOCUMENTS: '/documents',
  QUALITY_ISSUES: '/quality-issues',
  COMPLAINTS: '/quality-issues/complaints',
  KPIS: '/kpis',
  ORG_STRUCTURE: '/organization/structure',
  JOB_ROLES: '/organization/roles',
  STAFF: '/organization/staff',
  ORG_CHART: '/organization/chart',
  RISKS: '/risks',
  TRAINING: '/training',
  TRAINING_COURSES: '/training/courses',
  TRAINING_REQUIREMENTS: '/training/requirements',
  TRAINING_EVENTS: '/training/events',
  TRAINING_CALENDAR: '/training/calendar',
  TRAINING_COMPLIANCE: '/training/compliance',
  EQUIPMENT: '/equipment',
  AUDITS: '/audits',
  AUDIT_TEMPLATES: '/audits/templates',
  MANAGEMENT_REVIEWS: '/management-reviews',
  QMS_PLANNING: '/qms-planning',
  DESIGN_DEV: '/design-dev',
  SUPPLIERS: '/suppliers',
  INSPECTIONS: '/inspections',
  LESSONS_LEARNED: '/lessons-learned',
  CHANGE_MANAGEMENT: '/change-management',
  AI_ASSISTANT: '/ai-assistant',
  REPORTS: '/reports',
  SETTINGS: {
    ROOT: '/settings',
    GENERAL: '/settings/general',
    USERS: '/settings/users',
    CONFIGURATION: '/settings/configuration',
    AUDIT_LOGS: '/settings/audit-logs',
    NOTIFICATIONS: '/settings/notifications',
    AI: '/settings/ai',
    LOCALE: '/settings/locale',
    DATA_EXPORT: '/settings/data-export',
    DATA_IMPORT: '/settings/data-import',
    BILLING: '/settings/billing',
  },
  ADMIN: {
    ROOT: '/admin',
    PARTNERS: '/admin/partners',
    PARTNER_DETAIL: (id: string) => `/admin/partners/${id}`,
    ATTRIBUTIONS: '/admin/attributions',
    COMMISSION_EVENTS: '/admin/commission-events',
    PAYOUTS: '/admin/payouts',
    DASHBOARD: '/admin/dashboard',
  },
} as const;
